import { StyleSheet } from 'react-native-web';
import { colors } from '../../constants';

export default StyleSheet.create({
  container: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 10,
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  row: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 40,
  },
  flex: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowLabel: {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  rosterRulesHeading: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 20,
  },
  label: {
    fontWeight: 'bold',
  },
  midBorder: {
    paddingVertical: 20,
    borderTopColor: colors.lightGrey,
    borderTopWidth: 1,
  },
  topRow: {
    paddingVertical: 20,
  },
});
